import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { CustomLink } from "../../../components/Settings/CustomLink";
import Button1 from "../../../components/form/Button1";
import Icon from "../../../components/HOC/Icon";
import AgentSupplierSettingsModal from "./AgentSupplierSettingsModal";

export const supplierLinks = [
  {
    to: "/settings/supplier/",
    title: "",
    icon: "vaadin:cash",
    label: "Suppliers",
  },
  // {to: "/settings/supplier/markup", title: 'markup', icon: 'mdi:hand-coin',label: "Mark up"},
];

const SupplierContainer = () => {
  const location = useLocation();
  const [openAgentSupplierSettings, setOpenAgentSupplierSettings] =
    useState(false);
  let pathname = location.pathname.split("/");
  let page = pathname[pathname.length - 1];

  return (
    <div>
      <div className="flex flex-1 flex-col gap-4 w-full h-full">
        <div className="hidden sm:flex gap-2 overflow-x-auto overflow-hidden w-full items-center">
          {supplierLinks.map(({ to, title, icon, label }, i) => (
            <CustomLink
              key={i}
              to={to}
              active={!page ? title === "" : title === page}
              Icon={icon}
              label={label}
            />
          ))}
          <Button1
            className="btn-theme-light !justify-start !rounded-md !px-4 whitespace-nowrap !w-auto"
            onClick={() => setOpenAgentSupplierSettings(true)}
          >
            <Icon icon="mdi:account-cog" className="!w-4 !h-4" />
            Agent Supplier Settings
          </Button1>
        </div>
        <div className="sm:hidden vector-bg text-white p-2 flex items-center justify-between gap-2">
          <h3 className="capitalize text-white">{page || "Payout"}</h3>
          <button
            type="button"
            className="text-xs underline whitespace-nowrap"
            onClick={() => setOpenAgentSupplierSettings(true)}
          >
            Agent Supplier Settings
          </button>
        </div>

        <hr className="hidden sm:block mb-2" />
        <Outlet />
      </div>

      <AgentSupplierSettingsModal
        open={openAgentSupplierSettings}
        setOpen={setOpenAgentSupplierSettings}
      />
    </div>
  );
};

export default SupplierContainer;
